import { render, staticRenderFns } from "./ConsultaProcessoSuite2024.vue?vue&type=template&id=9bfcdfb6"
import script from "./ConsultaProcessoSuite2024.vue?vue&type=script&lang=js"
export * from "./ConsultaProcessoSuite2024.vue?vue&type=script&lang=js"
import style0 from "./ConsultaProcessoSuite2024.vue?vue&type=style&index=0&id=9bfcdfb6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports